import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto pb-5" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex items-center justify-between w-full" }
const _hoisted_5 = { class: "flex items-center w-1/2" }
const _hoisted_6 = { class: "flex flex-col grow" }
const _hoisted_7 = { class: "flex justify-end py-10" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex justify-between items-center mb-3" }
const _hoisted_10 = {
  key: 1,
  "aria-disabled": "true",
  class: "relative flex justify-center border-2 border-next-neu text-center hover:bg-next-neu hover:text-white px-3 py-1 ml-3 w-[129px]"
}
const _hoisted_11 = {
  key: 2,
  class: "text-next-bri col-span-2"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "flex justify-between items-center mb-3" }
const _hoisted_14 = {
  key: 1,
  "aria-disabled": "true",
  class: "relative flex justify-center border-2 border-next-neu text-center hover:bg-next-neu hover:text-white px-3 py-1 ml-3 w-[129px]"
}
const _hoisted_15 = {
  key: 2,
  class: "text-next-bri col-span-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_CercaModal = _resolveComponent("CercaModal")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ClientiSearchResult = _resolveComponent("ClientiSearchResult")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!
  const _component_ContattiSearchResult = _resolveComponent("ContattiSearchResult")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
        _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
        (_ctx.cercaModalVisibility)
          ? (_openBlock(), _createBlock(_component_CercaModal, {
              key: 0,
              settori_initial: _ctx.$route.query.settori,
              contatti_initial: _ctx.$route.query.contatti,
              accounts_initial: _ctx.$route.query.accounts,
              presentazioni_initial: _ctx.$route.query.presentazioni,
              responsabili_initial: _ctx.$route.query.responsabili,
              bu_initial: _ctx.$route.query.bu,
              text_initial: _ctx.$route.query.text,
              stato_initial: _ctx.$route.query.stato,
              ultimo_contatto_a_initial: _ctx.$route.query.ultimo_contatto_a,
              ultimo_contatto_da_initial: _ctx.$route.query.ultimo_contatto_da,
              nazioni_initial: _ctx.$route.query.aziende_estere,
              back: "",
              onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cercaModalVisibility = false)),
              onConfirm: _ctx.cerca
            }, null, 8, ["settori_initial", "contatti_initial", "accounts_initial", "presentazioni_initial", "responsabili_initial", "bu_initial", "text_initial", "stato_initial", "ultimo_contatto_a_initial", "ultimo_contatto_da_initial", "nazioni_initial", "onConfirm"]))
          : _createCommentVNode("", true)
      ]))
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"])
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-3xl font-bold mb-5" }, "Risultati Ricerca", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Field, {
                labelVisible: false,
                modelValue: _ctx.searchString,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchString) = $event)),
                placeholder: "Cerca"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cercaModalVisibility = !_ctx.cercaModalVisibility)),
                class: "pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_NextButton, {
              onClick: _ctx.buttonSearch,
              class: "px-3 py-1",
              variant: "outline-secondary"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Cerca ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Switcher, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event)),
            options: _ctx.getSwitchOptions
          }, null, 8, ["modelValue", "options"])
        ]),
        (_ctx.tab === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "font-medium text-3xl" }, "Clienti", -1)),
                _createElementVNode("div", null, [
                  (
                                !_ctx.loadingScaricaClienti &&
                                !_ctx.showClientiExportSuccess
                            )
                    ? (_openBlock(), _createBlock(_component_NextButton, {
                        key: 0,
                        variant: "outline-secondary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scarica('cl'))),
                        class: "px-3 py-1"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode(" Scarica XLSX ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loadingScaricaClienti)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[8] || (_cache[8] = [
                        _createElementVNode("div", { class: "lds-ring" }, [
                          _createElementVNode("div"),
                          _createElementVNode("div"),
                          _createElementVNode("div"),
                          _createElementVNode("div")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true),
                  (
                                _ctx.showClientiExportSuccess &&
                                !_ctx.loadingScaricaClienti
                            )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createTextVNode(" Il file è in generazione,")),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                        _cache[12] || (_cache[12] = _createTextVNode("attendi il completamento e scaricalo nella ")),
                        _createVNode(_component_RouterLink, {
                          to: { name: 'DownloadCenter' },
                          target: "_blank",
                          class: "underline"
                        }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("sezione download.")
                          ])),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaClienti.rows, (c) => {
                return (_openBlock(), _createBlock(_component_ClientiSearchResult, {
                  c: c,
                  key: c.id,
                  businessUnits: _ctx.businessUnits
                }, null, 8, ["c", "businessUnits"]))
              }), 128)),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaClienti.fetchNextPage,
                identifier: _ctx.listaClienti.identifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, " Non ci sono altri clienti. ", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "font-medium text-3xl" }, "Contatti", -1)),
                _createElementVNode("div", null, [
                  (
                                !_ctx.loadingScaricaContatti &&
                                !_ctx.showContattiExportSuccess
                            )
                    ? (_openBlock(), _createBlock(_component_NextButton, {
                        key: 0,
                        variant: "outline-secondary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scarica('co'))),
                        class: "px-3 py-1"
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode(" Scarica XLSX ")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loadingScaricaContatti)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[16] || (_cache[16] = [
                        _createElementVNode("div", { class: "lds-ring" }, [
                          _createElementVNode("div"),
                          _createElementVNode("div"),
                          _createElementVNode("div"),
                          _createElementVNode("div")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true),
                  (
                                _ctx.showContattiExportSuccess &&
                                !_ctx.loadingScaricaContatti
                            )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _cache[18] || (_cache[18] = _createTextVNode(" Il file è in generazione,")),
                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                        _cache[20] || (_cache[20] = _createTextVNode("attendi il completamento e scaricalo nella ")),
                        _createVNode(_component_RouterLink, {
                          to: { name: 'DownloadCenter' },
                          target: "_blank",
                          class: "underline"
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("sezione download.")
                          ])),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaContatti.rows, (c) => {
                return (_openBlock(), _createBlock(_component_ContattiSearchResult, { c: c }, null, 8, ["c"]))
              }), 256)),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaContatti.fetchNextPage,
                identifier: _ctx.listaContatti.identifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, " Non ci sono altri contatti. ", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
      ])
    ])
  ], 64))
}